import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    utcTime: String,
    format: { type: String, default: 'auto' },
  };

  connect() {
    if (this.utcTimeValue) {
      this.convertToLocalTime();
    }
  }

  convertToLocalTime() {
    const date = new Date(this.utcTimeValue);
    const today = new Date();
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    // Format time (hours:minutes AM/PM)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const timeString = `${formattedHours}:${formattedMinutes}${ampm}`;

    // Get the date format
    const day = date.getDate();
    const month = date
      .toLocaleString('en-US', { month: 'short' })
      .toLowerCase();
    const dateString = `${day} ${month}`;
    const dateTimeString = `${dateString}, ${timeString}`;

    // Set the formatted date/time based on the format value
    switch (this.formatValue) {
      case 'always_datetime':
        this.element.textContent = dateTimeString;
        break;
      case 'only_time':
        this.element.textContent = timeString;
        break;
      case 'only_date':
        this.element.textContent = dateString;
        break;
      case 'auto':
      default:
        this.element.textContent = isToday ? timeString : dateTimeString;
        break;
    }
  }
}
